import {
  Button,
  IconButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip,
} from "@mui/material";
import {
  getEditImplementArchetypePath,
  getEditImplementPath,
  getEditTractorArchetypePath,
  getEditTractorPath,
  Path,
} from "portal/utils/routing";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";
import React, { FC } from "react";

interface EditEquipmentButtonProps {
  equipmentId: string;
  type: "implement" | "implement-archetype" | "tractor" | "tractor-archetype";
  variant?: "icon" | "default" | "menuItem";
}
export const EditEquipmentButton: FC<EditEquipmentButtonProps> = ({
  equipmentId,
  type,
  variant = "default",
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  let url = Path.EQUIPMENT.toString();
  let label = t("utils.actions.edit");
  if (type === "implement") {
    url = getEditImplementPath(equipmentId);
    label = t("utils.actions.editLong", {
      subject: t("models.equipment.implement_one"),
    });
  }
  if (type === "implement-archetype") {
    url = getEditImplementArchetypePath(equipmentId);
    label = t("utils.actions.editLong", {
      subject: t("models.equipment.model_one"),
    });
  }
  if (type === "tractor") {
    url = getEditTractorPath(equipmentId);
  }
  if (type === "tractor-archetype") {
    url = getEditTractorArchetypePath(equipmentId);
    label = t("utils.actions.editLong", {
      subject: t("models.equipment.model_one"),
    });
  }
  if (variant === "icon") {
    return (
      <Tooltip title={t("utils.actions.edit")}>
        <IconButton size="small" color="inherit" onClick={() => navigate(url)}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    );
  }
  if (variant === "menuItem") {
    return (
      <MenuItem onClick={() => navigate(url)}>
        <ListItemIcon>
          <EditIcon />
        </ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
    );
  }
  return (
    <Button
      startIcon={<EditIcon />}
      color="inherit"
      className="justify-start"
      onClick={() => navigate(url)}
    >
      {label}
    </Button>
  );
};
